// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Ouroboros_Models_Brands_ErrorMessageText from "../Ouroboros.Models.Brands.ErrorMessageText/index.js";
import * as Ouroboros_Models_Brands_RequestState from "../Ouroboros.Models.Brands.RequestState/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Programs_TsBridgeHelpers from "../Ouroboros.Programs.TsBridgeHelpers/index.js";
import * as Ouroboros_Services_Clients_Interop_IO from "../Ouroboros.Services.Clients.Interop.IO/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
import * as Ouroboros_Services_Clients_Interop_Types from "../Ouroboros.Services.Clients.Interop.Types/index.js";
import * as TsBridge_Class from "../TsBridge.Class/index.js";
import * as TsBridge_DefaultImpls from "../TsBridge.DefaultImpls/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(TsBridge_Monad.bindTsBridgeM);
var tsBridge = /* #__PURE__ */ TsBridge_Class.tsBridge(/* #__PURE__ */ Ouroboros_Services_Clients_Interop_Types.tsBridgeIOts(/* #__PURE__ */ TsBridge_Class.tsBridgeRecord(/* #__PURE__ */ TsBridge_DefaultImpls.tsBridgeRecord1()(/* #__PURE__ */ TsBridge_DefaultImpls.tsBridgeRecordRLCons(/* #__PURE__ */ TsBridge_Class.tsBridgeByTok(TsBridge_Class.tsBridgeBoolean))(TsBridge_DefaultImpls.tsBridgeRecordRLNil)({
    reflectSymbol: function () {
        return "success";
    }
})))));
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var LoadingAction = function (x) {
    return x;
};
var tsBridgeLoadingAction = {
    tsBridge: function (v) {
        return bind(tsBridge(Type_Proxy["Proxy"].value))(function (valueType) {
            return pure(Ouroboros_Programs_TsBridgeHelpers.brandIntersection(valueType)("LoadingAction")("__brandLoadingAction"));
        });
    }
};
var mkLoadingAction = LoadingAction;
var mkLoadingController = function (env) {
    var stateHandle = Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(env.state));
    var errorHandle = Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(env.error));
    var emptyMessage = Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("");
    var setIdle = Ouroboros_Services_Clients_Interop_IO.sequenceOk([ errorHandle({
        message: emptyMessage,
        info: Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)
    }), stateHandle(Ouroboros_Models_Brands_RequestState.Idle.value) ]);
    var setSuccess = Ouroboros_Services_Clients_Interop_IO.sequenceOk([ errorHandle({
        message: emptyMessage,
        info: Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)
    }), stateHandle(Ouroboros_Models_Brands_RequestState.Success.value) ]);
    var defaultMessage = Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Something went wrong. Please try again.");
    var normalizeMessage = function (message) {
        var $16 = Ouroboros_Models_Brands_ErrorMessageText.unwrap(message) === "";
        if ($16) {
            return defaultMessage;
        };
        return message;
    };
    var setError = function (input) {
        return Ouroboros_Services_Clients_Interop_IO.sequenceOk([ errorHandle({
            message: normalizeMessage(input.message),
            info: input.info
        }), stateHandle(Ouroboros_Models_Brands_RequestState["Error"].value) ]);
    };
    return {
        setIdle: mkLoadingAction(setIdle),
        setLoading: mkLoadingAction(stateHandle(Ouroboros_Models_Brands_RequestState.Loading.value)),
        setSuccess: mkLoadingAction(setSuccess),
        setError: function (input) {
            return mkLoadingAction(setError(input));
        }
    };
};
var loadingActionToControllerAction = function (v) {
    return Ouroboros_Programs_Capabilities.mkControllerAction(v);
};
var documentationPath = "/documentation/drafting/frontend-program-builder/controllers/loading_controller.md";
export {
    LoadingAction,
    mkLoadingController,
    loadingActionToControllerAction,
    documentationPath,
    tsBridgeLoadingAction
};
//# sourceMappingURL=index.js.map
